<template>
  <div>
    <div class="d-left">
      <erp-tree @node-click="nodeClick"></erp-tree>
    </div>
    <div class="d-right">
      <el-button size="mini" style="margin-top: 5px" @click="search"
        >查询</el-button
      >
      <el-button size="mini" style="margin-top: 5px" @click="openDialog"
        >产生托收单</el-button
      >
      <el-button size="mini" style="margin-top: 5px" @click="del(1)"
        >删除</el-button
      >
      <el-button size="mini" style="margin-top: 5px" @click="del(2)"
        >全部删除</el-button
      >
      <el-button size="mini" style="margin-top: 5px" @click="delComplete">
        删除已托收
      </el-button>
      <el-button size="mini" style="margin-top: 5px" @click="excel(1)"
        >导出Excel(以账号汇总)</el-button
      >
      <el-button size="mini" style="margin-top: 5px" @click="excel(2)"
        >导出Excel(以房产汇总)</el-button
      >
<!--      <el-button size="mini" style="margin-top: 5px" @click="alertNotice"
        >导出Excel(以计费周期汇总)</el-button
      >
      <el-button size="mini" style="margin-top: 5px" @click="alertNotice"
        >导出广州银联txt</el-button
      >-->
      <el-button size="mini" style="margin-top: 5px" @click="excel(3)"
        >导出托盘文件</el-button
      >
<!--      <el-button size="mini" style="margin-top: 5px" @click="alertNotice"
        >导出代扣文件</el-button
      >
      <el-button size="mini" style="margin-top: 5px">建设银行托收</el-button>
      <el-button size="mini" style="margin-top: 5px" @click="alertNotice"
        >下载明细文件</el-button
      >
      <el-button size="mini" style="margin-top: 5px" @click="alertNotice"
        >下载汇总文件</el-button
      >-->
      <el-button size="mini" style="margin-top: 5px" @click="importModel"
        >导入回盘文件</el-button
      >
<!--      <el-button size="mini" style="margin-top: 5px" @click="alertNotice"
        >文件设置</el-button
      >
      <el-button size="mini" style="margin-top: 5px" @click="alertNotice"
        >托收房产设置</el-button
      >
      <el-button size="mini" style="margin-top: 5px" @click="alertNotice"
        >导出银行托收明细Excel</el-button
      >-->

      <el-descriptions :column="2" size="mini" border style="margin-top: 8px">
        <el-descriptions-item label="房产">
          <el-input
            size="mini"
            v-model="form.houseName"
            placeholder="输入房产搜索"
          ></el-input>
        </el-descriptions-item>
        <el-descriptions-item label=""> </el-descriptions-item>
        <el-descriptions-item label="收费项目">
          <el-select
            v-model="form.chargeItemId"
            size="mini"
            filterable
            clearable
            style="width: 70%"
            placeholder="选择收费项目"
          >
            <el-option
              size="mini"
              v-for="item in chargeitem"
              :key="item.id"
              :label="item.chargeItem_name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="开户银行">
          <el-input
            size="mini"
            v-model="form.bank"
            placeholder="输入开户银行搜索"
          ></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="代扣单位">
          <el-select
            v-model="form.replaceUnit"
            size="mini"
            filterable
            clearable
            collapse-tags
            style="width: 70%"
            placeholder="选择代扣单位"
          >
            <el-option
              size="mini"
              v-for="item in replaceUnits"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="托收类型">
          <el-select
            v-model="form.replaceType"
            size="mini"
            filterable
            clearable
            style="width: 70%"
            placeholder="选择托收类型"
          >
            <el-option
              size="mini"
              v-for="item in replaceTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="计费周期">
          <el-date-picker
            v-model="startDate"
            size="mini"
            type="date"
            format="yyyy-MM-dd"
            value-format="timestamp"
            placeholder="选择开始日期"
          />
          至
          <el-date-picker
            v-model="endDate"
            size="mini"
            type="date"
            format="yyyy-MM-dd"
            value-format="timestamp"
            placeholder="选择结束日期"
          />
        </el-descriptions-item>
        <el-descriptions-item label="报盘日期">
          <el-date-picker
            v-model="appearStartDate"
            size="mini"
            type="date"
            format="yyyy-MM-dd"
            value-format="timestamp"
            placeholder="选择开始日期"
          />
          至
          <el-date-picker
            v-model="appearEndDate"
            size="mini"
            type="date"
            format="yyyy-MM-dd"
            value-format="timestamp"
            placeholder="选择结束日期"
          />
        </el-descriptions-item>
        <el-descriptions-item label="托收状态">
          <el-select
            v-model="form.status"
            size="mini"
            filterable
            clearable
            style="width: 70%"
            placeholder="选择托收状态"
          >
            <el-option label="未托收" value="0" />
            <el-option label="已托收" value="1" />
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="手动缴款">
          <el-select
            v-model="form.auto"
            size="mini"
            filterable
            clearable
            collapse-tags
            style="width: 70%"
            placeholder="选择托收状态"
          >
            <el-option label="否" value="0" />
            <el-option label="是" value="1" />
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="客户名称">
          <el-input
            size="mini"
            v-model="form.customerName"
            placeholder="输入客户名称搜索"
          ></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="银行卡号">
          <el-input
            size="mini"
            v-model="form.bankNo"
            placeholder="输入银行卡号搜索"
          ></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="报盘人员">
          <el-input
            size="mini"
            v-model="form.appearUser"
            placeholder="输入报盘人员搜索"
          ></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="回盘人员">
          <el-input
            size="mini"
            v-model="form.replyUser"
            placeholder="输入回盘人员搜索"
          ></el-input>
        </el-descriptions-item>
      </el-descriptions>
      <div style="margin-top: 5px">
        <el-button size="mini" @click="excel2"> 导出 </el-button>
      </div>
      <el-table
        max-height="450px"
        :data="listData"
        border
        style="margin-top: 8px"
        @selection-change="handleSelectionChange"
        v-loading="loading"
      >
        <el-table-column type="selection" width="55" />
        <el-table-column label="客户姓名" prop="customerName" />
        <el-table-column label="房产名称" prop="h_name_date" />
        <el-table-column label="代扣单位 " prop="agency_unit" />
        <el-table-column label="银行卡号" prop="bank_no" />
        <el-table-column label="收费项目" prop="chargeItem_name" />
        <el-table-column label="计费周期" prop="billingCycle" />
        <el-table-column label="报盘金额" prop="appear_amount" />
        <el-table-column label="回盘金额" prop="reply_amount" />
        <el-table-column label="托收状态" prop="status" />
        <el-table-column label="报盘日期" prop="appear_date" />
        <el-table-column label="报盘人员" prop="appear_user" />
        <el-table-column label="回盘日期" prop="reply_date" />
        <el-table-column label="回盘人员" prop="reply_user" />
        <el-table-column label="回盘说明 " prop="remark" />
      </el-table>
      <el-pagination
        style="float: right; margin-top: 10px; margin-right: 20px"
        background
        @size-change="handleSizeChange"
        :page-sizes="[20,50,100, 200, 500]"
        :small="true"
        layout="sizes,prev, pager, next"
        :page-size="form.pageSize"
        :total="totalCount"
        :current-page.sync="form.page"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="批量产生银行托收单"
      :visible.sync="modal"
      width="60%"
      :before-close="handleClose"
      v-loading="loading"
    >
      <el-form
        ref="form"
        :model="createData"
        label-width="120px"
        :rules="rules"
      >
        <el-form-item label="收费项目" prop="chargeItemId">
          <el-select
            v-model="createData.chargeItemId"
            size="mini"
            filterable
            multiple
            style="width: 70%"
            placeholder="选择收费项目"
          >
            <el-option
              size="mini"
              v-for="item in chargeitem"
              :key="item.id"
              :label="item.chargeItem_name"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <span style="cursor: pointer" @click="complete">全选</span>
          <span style="margin-left: 3px; cursor: pointer" @click="cancel"
            >取消</span
          >
        </el-form-item>
        <el-form-item label="计费开始日期" prop="startDate">
          <el-date-picker
            v-model="createStartDate"
            size="mini"
            type="date"
            format="yyyy-MM-dd"
            value-format="timestamp"
            placeholder="选择开始日期"
          />
        </el-form-item>
        <el-form-item label="计费结束日期" prop="endDate">
          <el-date-picker
            v-model="createEndDate"
            size="mini"
            type="date"
            format="yyyy-MM-dd"
            value-format="timestamp"
            placeholder="选择结束日期"
          />
        </el-form-item>
        <el-form-item label="银行报盘日期" prop="appearDate">
          <el-date-picker
            v-model="appearDate"
            size="mini"
            type="date"
            format="yyyy-MM-dd"
            value-format="timestamp"
            placeholder="选择银行报盘日期"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="createDeduction">保存</el-button>
          <el-button @click="handleClose">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="导入回盘文件"
      :visible.sync="importVisible"
      width="60%"
      :before-close="handleCloseImport"
      v-loading="loading"
    >
      <el-upload
        class="upload-demo"
        :action="url"
        :before-remove="beforeRemove"
        :on-success="handleAvatarSuccess"
        accept=".xls,.xlsx"
        :limit="1"
        :on-exceed="handleExceed"
        :file-list="fileList"
        :before-upload="beforeAvatarUpload"
      >
        <el-button size="small" type="primary" class="texts">
          点击上传
        </el-button>
        <div slot="tip" class="el-upload__tip">
          只能上传xls或xlsx文件，且不超过7M
        </div>
      </el-upload>
      <el-button size="mini" @click="delNode"> 删除 </el-button>
      <el-button size="mini" @click="importExcelData"> 导入回盘 </el-button>
      <el-table
        max-height="450px"
        :data="importData"
        border
        style="margin-top: 8px"
        @selection-change="handleSelectionChangeImport"
      >
        <el-table-column type="selection" width="55" />
        <el-table-column label="银行卡号" prop="bankNo" />
        <el-table-column label="收费项目名" prop="chargeItemName" />
        <el-table-column label="报盘日期" prop="appearDate" />
        <el-table-column label="回盘金额" prop="replyAmount" />
        <el-table-column label="票据类型" prop="billType" />
        <el-table-column label="票据号码" prop="billNo" />
        <el-table-column label="票据代码" prop="billCode" />
        <el-table-column label="系统编号" prop="id" />
        <el-table-column label="房产名称" prop="houseName" />
      </el-table>
    </el-dialog>
  </div>
</template>

  <script>
import ErpTree from "@/components/Admin/Common/erp-tree";
import imgurl from "@/assets/js/imgurl.js";
export default {
  name: "OrderBankDeduction",
  components: {
    ErpTree,
  },
  data() {
    return {
      listData: [],
      form: {
        houseName: "",
        startDate: "",
        endDate: "",
        appearStartDate: "",
        appearEndDate: "",
        chargeItemId: "",
        bank: "",
        replaceUnit: "",
        replaceType: "",
        status: "",
        auto: "0",
        customerName: "",
        bankNo: "",
        appearUser: "",
        replyUser: "",
        page: 1,
        pageSize: 10,
      },
      startDate: "",
      endDate: "",
      appearStartDate: "",
      appearEndDate: "",
      createStartDate: "",
      createEndDate: "",
      appearDate: "",
      totalCount: 0,
      pid: 0,
      houseId: 0,
      house: [],
      chargeitem: [],
      replaceUnits: [
        {
          label: "工商银行代扣",
          value: "工商银行代扣",
        },
        {
          label: "广州农商银行代扣",
          value: "广州农商银行代扣",
        },
        {
          label: "广州银联代扣",
          value: "广州银联代扣",
        },
        {
          label: "光大银行代扣",
          value: "光大银行代扣",
        },
        {
          label: "拉卡拉代扣",
          value: "拉卡拉代扣",
        },
        {
          label: "交通银行代扣",
          value: "交通银行代扣",
        },
        {
          label: "南海农村商业银行代扣",
          value: "南海农村商业银行代扣",
        },
      ],
      replaceTypes: [
        {
          label: "光大托收",
          value: "光大托收",
        },
        {
          label: "银联托收",
          value: "银联托收",
        },
      ],
      createData: {
        pid: 0,
        chargeItemId: [],
        startDate: "",
        endDate: "",
        houseId: 0,
        appearDate: "",
      },
      datas: [],
      ids: [],
      modal: false,
      loading: false,
      rules: {
        chargeItemId: [
          { required: true, message: "请选择收费项目", trigger: "blur" },
        ],
        startDate: [
          {
            required: true,
            message: "请选择计费周期开始时间",
            trigger: "blur",
          },
        ],
        endDate: [
          {
            required: true,
            message: "请选择计费周期结束时间",
            trigger: "blur",
          },
        ],
        appearDate: [
          {
            required: true,
            message: "请选择银行报盘日期",
            trigger: "blur",
          },
        ],
      },
      importVisible: false,
      url: "",
      fileList: [],
      importData: [],
      multipleSelection: [],
    };
  },
  mounted() {
    //加载收费大类（费项）
    this.$myhttp
      .get("admin/common/getChargeitem", {
        "Content-Type": "application/json",
      })
      .then((backdata) => {
        this.chargeitem = backdata.data.data;
      });
    var login = window.localStorage.getItem("login");
    var token = window.localStorage.getItem("token");
    var oa_user_id = window.localStorage.getItem("oa_user_id");
    this.url =
      this.$myhttp.defaults.baseURL +
      "/admin/BankDeduction/importExcel?" +
      "login_name=" +
      login +
      "&token=" +
      token +
      "&oa_user_id=" +
      oa_user_id;
  },
  watch: {
    "form.page"(n) {
      this.search();
    },
  },
  methods: {
    nodeClick(data) {
      if (data.type == "project") {
        this.pid = data.id;
      }
      if (data.type == "room") {
        this.houseId = data.id;
      }
      let tree_str = data.tree
        .map((ret) => {
          return ret.name;
        })
        .join("->");
      this.form.houseName = tree_str;
    },
    search() {
      if (this.pid === 0) {
        this.$message.error("请选择项目");
        return;
      }
      this.form.startDate = this.startDate / 1000;
      this.form.endDate = this.endDate / 1000;
      this.form.appearStartDate = this.appearStartDate / 1000;
      this.form.appearEndDate = this.appearEndDate / 1000;
      this.form.pid = this.pid;
      this.loading = true;
      this.$myhttp
        .post("admin/BankDeduction/index", this.form, {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.listData = backdata.data.data;
            this.totalCount = backdata.data.totalCount;
            this.form.page = backdata.data.page;
            this.loading = false;
          } else {
            this.$message.error(backdata.data.msg);
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$message.error(err);
          this.loading = false;
        });
    },
    handleSelectionChange(val) {
      this.datas = val;
      let ids = [];
      this.datas.map((req) => {
        ids.push(req.id);
      });
      this.ids = ids;
    },
    del(type) {
      if (this.pid === 0) {
        this.$message.error("请选择项目");
        return;
      }
      let tips = "";
      if (type == 1) {
        tips = "此操作将删除已选中托收，是否继续操作？";
      } else {
        tips = "此操作将删除全部托收单，是否继续操作？";
      }
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          this.form.startDate = this.startDate / 1000;
          this.form.endDate = this.endDate / 1000;
          this.form.appearStartDate = this.appearStartDate / 1000;
          this.form.appearEndDate = this.appearEndDate / 1000;
          this.form.pid = this.pid;
          this.form.ids = this.ids;
          this.form.type = type;
          this.$myhttp
            .post("admin/BankDeduction/deleteDeduction", this.form, {
              "Content-Type": "application/json",
            })
            .then((backdata) => {
              if (backdata.data.code == 200) {
                this.$message.success(backdata.data.msg);
                this.search();
                this.loading = false;
              } else {
                this.$message.error(backdata.data.msg);
                this.loading = false;
              }
            })
            .catch((err) => {
              this.$message.error(err);
              this.loading = false;
            });
        })
        .catch(() => {});
    },
    openDialog() {
      if (this.pid == 0) {
        this.$message.error("请选择项目");
        return;
      }
      this.$confirm(
        "生成新的托收单将会删除之前未托收的托收单，是否继续操作",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.modal = true;
        })
        .catch(() => {});
    },
    handleClose() {
      this.modal = false;
    },
    createDeduction() {
      if (this.pid == 0) {
        this.$message.error("请选择项目");
        return;
      }
      if (this.createStartDate == "") {
        this.$message.error("请选择计费周期开始时间");
        return;
      }
      if (this.createEndDate == "") {
        this.$message.error("请选择计费周期结束时间");
        return;
      }
      if (this.appearDate == "") {
        this.$message.error("请选择银行报盘日期");
        return;
      }
      this.loading = true;
      this.createData.pid = this.pid;
      this.createData.houseId = this.houseId;
      this.createData.startDate = this.createStartDate / 1000;
      this.createData.endDate = this.createEndDate / 1000;
      this.createData.appearDate = this.appearDate / 1000;
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.$myhttp
            .post("admin/BankDeduction/createDeduction", this.createData, {
              "Content-Type": "application/json",
            })
            .then((backdata) => {
              if (backdata.data.code == 200) {
                this.$message.success(backdata.data.msg);
                this.search(1);
                this.loading = false;
                this.handleClose();
              } else {
                this.loading = false;
                this.$message.error(backdata.data.msg);
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error(err);
            });
        } else {
          this.loading = false;
        }
      });
    },
    alertNotice() {
      this.$message.success("功能正在开发");
    },
    excel(type) {
      if (this.pid === 0) {
        this.$message.error("请选择项目");
        return;
      }
      ERP.showLoading();
      this.form.startDate = this.startDate / 1000;
      this.form.endDate = this.endDate / 1000;
      this.form.appearStartDate = this.appearStartDate / 1000;
      this.form.appearEndDate = this.appearEndDate / 1000;
      this.form.pid = this.pid;
      this.form.type = type;
      this.$myhttp
        .post("admin/BankDeduction/excel", this.form, {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          if (backdata.data.code == 200) {
            let url = imgurl + backdata.data.data;
            ERP.hideLoading();
            window.open("/office.html#/office?url=" + url, "_blank");
          } else {
            this.$message.error(backdata.data.msg);
            ERP.hideLoading();
          }
        })
        .catch((err) => {
          this.$message.error(err);
          ERP.hideLoading();
        });
    },
    importModel() {
      if (this.pid === 0) {
        this.$message.error("请选择项目");
        return;
      }
      this.importVisible = true;
    },
    handleCloseImport() {
      this.importVisible = false;
    },
    //删除
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.importData = [];
        })
        .catch(() => {});
    },
    handleAvatarSuccess(response, file, fileList) {
      if (response.code == 200) {
        this.importData = response.data.length > 0 ? response.data : [];
      }
    },
    //超过一个文件
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    //限制大小
    beforeAvatarUpload(file) {
      const isLt7M = file.size / 1024 / 1024 < 8;
      if (!isLt7M) {
        this.$message.error("上传文件大小不能超过 8MB!");
      }
      return isLt7M;
    },
    handleSelectionChangeImport(val) {
      this.multipleSelection = val;
    },
    // 删除节点
    delNode() {
      if (this.multipleSelection.length == 0) {
        return;
      }
      let data = [];
      if (this.importData.length == this.multipleSelection.length) {
        this.importData = [];
        this.multipleSelection = [];
      } else {
        this.importData.map((req) => {
          let bool = true;
          this.multipleSelection.map((reqs) => {
            if (req.id == reqs.id) {
              bool = false;
            }
          });
          if (bool) {
            data.push(req);
          }
        });
      }
      this.importData = data;
    },
    // 删除已回盘
    delComplete(){
      this.$confirm("确认删除已托收数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
          this.loading = true;
          this.form.pid = this.pid;
          this.form.ids = this.ids;
          this.$myhttp
            .post("admin/BankDeduction/deleteCompleteDeduction", this.form, {
              "Content-Type": "application/json",
            })
            .then((backdata) => {
              if (backdata.data.code == 200) {
                this.$message.success(backdata.data.msg);
                this.search();
                this.loading = false;
              } else {
                this.$message.error(backdata.data.msg);
                this.loading = false;
              }
            })
            .catch((err) => {
              this.$message.error(err);
              this.loading = false;
            });
        })
        .catch(() => {});
    },
    importExcelData() {
      this.loading = true;
      this.$myhttp
        .post(
          "admin/BankDeduction/importExcelData",
          { data: this.importData, pid: this.pid },
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.$message.success(backdata.data.msg);
            this.search(1);
            this.loading = false;
          } else {
            this.$message.error(backdata.data.msg);
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$message.error(err);
          this.loading = false;
        });
    },
    excel2() {
      if (this.pid === 0) {
        this.$message.error("请选择项目");
        return;
      }
      ERP.showLoading();
      this.form.startDate = this.startDate / 1000;
      this.form.endDate = this.endDate / 1000;
      this.form.appearStartDate = this.appearStartDate / 1000;
      this.form.appearEndDate = this.appearEndDate / 1000;
      this.form.pid = this.pid;
      this.$myhttp
        .post("admin/BankDeduction/excelList", this.form, {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          if (backdata.data.code == 200) {
            let url = imgurl + backdata.data.data;
            ERP.hideLoading();
            window.open("/office.html#/office?url=" + url, "_blank");
          } else {
            this.$message.error(backdata.data.msg);
            ERP.hideLoading();
          }
        })
        .catch((err) => {
          this.$message.error(err);
          ERP.hideLoading();
        });
    },
    downloadExcel() {
      let url = imgurl + "/excel/回盘文件模板.xlsx";
      window.open("/office.html#/office?url=" + url, "_blank");
    },
    complete() {
      let data = this.chargeitem;
      let id = data
        .map((ret) => {
          return ret.id;
        })
        .join(",");
      let idarray = "[" + id + "]";
      this.createData.chargeItemId = JSON.parse(idarray);
    },
    //取消
    cancel() {
      this.createData.chargeItemId = [];
    },
    handleSizeChange(val) {
      this.form.pageSize = val;
      this.search();
    },
  },
};
</script>

  <style>
.d-left {
  border-right: 1px solid #eee;
  width: 250px;
  float: left;
}
.d-right {
  float: right;
  width: calc(100% - 253px);
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/bankDeduction.vue